export const money = (n) => `$${Math.round(n || 0).toLocaleString()}`;

export const signedMoney = (n) => {
  if (!n) return '$0';
  const sign = n > 0 ? '+' : '−';
  return `${sign}$${Math.abs(Math.round(n)).toLocaleString()}`;
};

export const formatDriver = (d) => {
  if (!d) return '';
  return d.detail ? `${d.label} (${d.detail})` : d.label;
};

export const formatShortDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  } catch {
    return iso;
  }
};

export const SERVICE_MONTHS_LABEL = {
  '2026-04-01': 'April 2026',
  '2026-03-01': 'March 2026',
  '2026-02-01': 'February 2026',
  '2026-01-01': 'January 2026',
  APR: 'April 2026',
  MAR: 'March 2026',
  FEB: 'February 2026',
  JAN: 'January 2026',
};
